import axios from 'axios'
import { API_BASE } from '../config'

function authHeaders() {
    return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
}

export default class Games {
    // GET /game/link/:code - A game's sign-in link: { success, game, approved }. Rejects if the code has expired.
    getLink(code) {
        return axios.get(`${API_BASE}/game/link/${encodeURIComponent(code)}`).then(x => x.data);
    }

    // POST /game/link/approve - Sign the waiting game in as the logged-in user: { success, username }
    approveLink(code) {
        return axios.post(`${API_BASE}/game/link/approve`, { code }, authHeaders()).then(x => x.data);
    }

    // GET /spacejump/leaderboard - Every Space Jump board's top players:
    // { run, levels: [{ id, name }], boards: { <board>: { fastest: [entry], jumps: [entry] } } }
    getSpaceJumpLeaderboard() {
        return axios.get(`${API_BASE}/spacejump/leaderboard`).then(x => x.data);
    }

}
